// import React, { useEffect } from 'react';
// import mithra from "../../Assets/Images/Mitra-QSR-logo.png";
// import './Login.css'; // Import the CSS file for styling
// import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';



// export const Logintab = () => {
//  const [store_id, setStore_id] = useState("");
//   const [loading, setLoading] = useState(false);
// const navigate = useNavigate()



//   const getCustomTokenCallback = async () => {
//     const resp = await fetch(`/server/login-function/login`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ store_id }),
//     });

//     const customToken = await resp.json();

//     console.log("customToken",customToken)
//     if (!resp.ok) throw new Error(customToken.error || "Token fetch failed");

//     return {
//       client_id: customToken.client_id,
//       scopes: customToken.scopes,
//       jwt_token: customToken.authToken.jwt_token,
//     };
//   };

//   const handleLogin = async () => {
//     if (!store_id) {
//       alert("Please enter Store ID");
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await fetch("/server/login-function/login", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ store_id }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         alert(data.error || "Login failed");
//         return;
//       }

//       const catalyst = window.catalyst;

//       await catalyst.auth.signinWithJwt(async () => ({
//         client_id: data.authToken.client_id,
//         scopes: data.authToken.scopes,
//         jwt_token: data.authToken.jwt_token,
//       }));

//       // Store user details in sessionStorage
//       sessionStorage.setItem("store_id", data.store.store_id);
//       sessionStorage.setItem("store_name", data.store.store_name);
//       sessionStorage.setItem("email", data.store.email);
// sessionStorage.setItem('token', data.authToken)

//       navigate("/home");
//     } catch (error) {
//       console.error("Login failed:", error);
//       alert("Authentication failed");
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleNext = async () => {
//     if (!store_id) {
//       alert("Please enter Store ID");
//       return;
//     }

//     setLoading(true);

//     try {
//       // Call your Catalyst backend function
//       const resp = await fetch("/server/login-function/login", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ store_id }),
//       });

//       const data = await resp.json();

//       const storedata = data.store

// sessionStorage.setItem("store_id",storedata.store_id)
// sessionStorage.setItem("token",storedata.token)
//       sessionStorage.setItem("email",storedata.email)
//       sessionStorage.setItem("first_name",storedata.first_name)
//       sessionStorage.setItem("last_name",storedata.last_name)


//       console.log("login data",data)
//       if (!resp.ok) {
//         alert(data.error || "Login failed");
//         setLoading(false);
//         return;
//       }

//       // Catalyst JWT login
//       // const catalyst = window.catalyst;
//       // await catalyst.auth.signinWithJwt(async () => {
//       //   return {
//       //     client_id: data.client_id,
//       //     scopes: data.scopes,
//       //     jwt_token: data.jwt_token,
//       //   };
//       // });



//       navigate("/home")
//       // Redirect or load next page
//       // e.g., navigate("/dashboard")
//     } catch (err) {
//       console.error(err);
//       alert("❌ Login failed due to server error");
//     } finally {
//       setLoading(false);
//     }
//   };
//     const handleKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleLogin();
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-pic p-4">
//       <div className="w-full max-w-md flex flex-col items-center gap-4">
//         {/* Logo on top */}
//         <img src={mithra} alt="Mithra QSR Logo" className="w-40 object-contain" />

//         {/* Login form container */}
//           <div className=" flex items-center justify-center ">
// <div className="bg-white/30 backdrop-blur-md rounded-lg shadow-2xl p-8 w-full max-w-md m-5">
//         {/* Logo */}
        

//         {/* Sign in heading */}
//         <h2 className="text-2xl font-semibold text-center mb-8">Sign in</h2>

//         {/* Email input */}
//         <div className="space-y-6">
//           <div>
//             <input
//               type="store_id"
//               value={store_id}
//               onChange={(e) => setStore_id(e.target.value)}
//               onKeyPress={handleKeyPress}
//               placeholder="Enter Your Store ID"
//               className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
//             />
//           </div>

//           {/* Next button */}
//           <button
//             onClick={handleLogin}
//             className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded transition-colors duration-200 uppercase tracking-wide"
//           >
//             Login
//           </button>

//           {/* Forgot password link */}
//           {/* <div className="text-center">
//             <button
//               onClick={() => console.log('Forgot password clicked')}
//               className="text-gray-600 hover:text-gray-800 text-sm transition-colors"
//             >
//               Forgot Password?
//             </button>
//           </div> */}
//         </div>
//       </div>
//     </div>
//       </div>
//     </div>
//   );
// };
import React, { useEffect } from 'react';
import mithra from "../../Assets/Images/Mitra-QSR-logo.png";
import './Login.css'; // Import the CSS file for styling

export const Logintab = () => {
  useEffect(() => {
    const config = {
      css_url: "/app/embeddediframe.css",
      forgot_password_css_url: "/app/embedded_password_reset.css",
    };
    window.catalyst.auth.signIn("loginDiv", config);
    
    // After successful login, get user info and fetch store_id
    const checkLoginStatus = setInterval(async () => {
      try {
        const user = await window.catalyst.auth.getLoggedInUser();
        if (user && user.email) {
          console.log("User logged in with email:", user.email);
          
          clearInterval(checkLoginStatus); // Stop checking immediately
          
          try {
            // Get store_id from backend using email - WAIT FOR THIS TO COMPLETE
            const resp = await fetch("/server/login-function/login", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ email: user.email }),
            });

            const data = await resp.json();
            console.log("Full login response:", data);
            
            // Handle the response structure - data might be wrapped in array or have store property
            let storedata = null;
            
            if (Array.isArray(data) && data.length > 0) {
              storedata = data[0]?.store || data[0]?.storeData || data[0];
            } else if (data.store) {
              storedata = data.store;
            } else {
              storedata = data;
            }
            
            console.log("Extracted store data:", storedata);
            
            // Store all necessary data in sessionStorage BEFORE redirect
            if (storedata && storedata.store_id) {
              sessionStorage.setItem("store_id", storedata.store_id);
              console.log("✅ Store ID saved to sessionStorage:", storedata.store_id);
            } else {
              console.error("❌ store_id not found in response");
            }
            
            if (user.email) {
              sessionStorage.setItem("email", user.email);
            }
            
            if (storedata && storedata.first_name) {
              sessionStorage.setItem("userName", storedata.first_name);
            }
            
            // Dispatch event to notify Header that sessionStorage is updated
            window.dispatchEvent(new Event('sessionStorageUpdate'));
            console.log("📢 sessionStorageUpdate event dispatched");
            
            // Small delay to ensure event is processed before redirect
            setTimeout(() => {
              console.log("Redirecting to /home...");
              window.location.href = "/home";
            }, 50);
            
          } catch (error) {
            console.error("Error fetching store data:", error);
            // Still redirect if there's an error, but store_id won't be set
            window.location.href = "/home";
          }
        }
      } catch (error) {
        console.error("Error checking login status:", error);
      }
    }, 500);
    
    // Clear interval after 30 seconds if login doesn't complete
    setTimeout(() => clearInterval(checkLoginStatus), 30000);
    
    // Clear interval after 30 seconds if login doesn't complete
    setTimeout(() => clearInterval(checkLoginStatus), 30000);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-pic p-4">
      <div className="w-full max-w-md flex flex-col items-center gap-4">
        {/* Logo on top */}
        <img src={mithra} alt="Mithra QSR Logo" className="w-40 object-contain" />

        {/* Login form container */}
        <div
          className="w-full rounded-2xl shadow-lg p-4 md:p-6"
          id="loginDiv"
          style={{ height: '50vh',  }}
        ></div>
      </div>
    </div>
  );
};
